<div class="container">
	<div class="time-frame">
		<h3>Group By Every:</h3>
		<input matInput type="number" max="365" min="1" step="1" [value]="selectedInterval" (change)="intervalInputChanged($event)">
		@if (selectedTimeFrame) {
		<mat-select #TimeFilter [value]="selectedTimeFrame.iD" (valueChange)="timeFrameInputChanged(TimeFilter.value)">
			@for (item of TimeFrames; track item.iD) {
			<mat-option [value]="item.iD">{{item.name}}</mat-option>
			}
		</mat-select>
		}
	</div>
	<div class="time-period">
		<h3>For:</h3>
		<mat-select #TimePeriod [value]="selectedTimePeriod.iD" (valueChange)="timePeriodInputChanged(TimePeriod.value)">
			@for (item of TimePeriods; track item.iD) {
			<mat-option [value]="item.iD">{{item.name}}</mat-option>
			}
		</mat-select>
	</div>
</div>